import { render, staticRenderFns } from "./RequestOverview.vue?vue&type=template&id=2fdb68e0"
import script from "./RequestOverview.vue?vue&type=script&lang=ts"
export * from "./RequestOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports